export const setFeatureFlags = (featureFlags) => ({
    type: 'SET_FEATURE_FLAGS',
    featureFlags
});